import { CoreLink } from '@uncinc/react-drupal-core';
import React from 'react';

interface Props {
  listItems: {
    title: string;
    href: string;
    className?: string;
  }[];
}


const LinkListSecondary: React.FC<Props> = (props) => {
  const { listItems } = props;
  return (
    <ul className="Footer__link-list-secondary">
      {listItems.map((item) => {
        return (
          <li key={item.href} className={`Footer__link-list-secondary-item ${item.className ? item.className : ''}`}>
            <CoreLink to={item.href}>
              {item.title}
            </CoreLink>
          </li>
        );
      })}
    </ul>
  );
};

export default LinkListSecondary;
